var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.851562,
    width: 40.2529,
    height: 40,
    rx: 20,
    fill: "#ECE6F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3180_107409",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 29,
    height: 29
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.125,
    y: 6.85156,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3180_107409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1263 20.8519C18.843 20.8519 17.7444 20.3949 16.8305 19.4811C15.9166 18.5672 15.4596 17.4686 15.4596 16.1852C15.4596 14.9019 15.9166 13.8033 16.8305 12.8894C17.7444 11.9755 18.843 11.5186 20.1263 11.5186C21.4096 11.5186 22.5082 11.9755 23.4221 12.8894C24.336 13.8033 24.793 14.9019 24.793 16.1852C24.793 17.4686 24.336 18.5672 23.4221 19.4811C22.5082 20.3949 21.4096 20.8519 20.1263 20.8519ZM10.793 30.1852V26.9186C10.793 26.2574 10.9631 25.6498 11.3034 25.0956C11.6437 24.5415 12.0957 24.1186 12.6596 23.8269C13.8652 23.2241 15.0902 22.772 16.3346 22.4706C17.5791 22.1692 18.843 22.0186 20.1263 22.0186C21.4096 22.0186 22.6735 22.1692 23.918 22.4706C25.1624 22.772 26.3874 23.2241 27.593 23.8269C28.1569 24.1186 28.6089 24.5415 28.9492 25.0956C29.2895 25.6498 29.4596 26.2574 29.4596 26.9186V30.1852H10.793ZM13.1263 27.8519H27.1263V26.9186C27.1263 26.7047 27.0728 26.5102 26.9659 26.3352C26.8589 26.1602 26.718 26.0241 26.543 25.9269C25.493 25.4019 24.4332 25.0081 23.3638 24.7456C22.2944 24.4831 21.2152 24.3519 20.1263 24.3519C19.0374 24.3519 17.9582 24.4831 16.8888 24.7456C15.8194 25.0081 14.7596 25.4019 13.7096 25.9269C13.5346 26.0241 13.3937 26.1602 13.2867 26.3352C13.1798 26.5102 13.1263 26.7047 13.1263 26.9186V27.8519ZM20.1263 18.5186C20.768 18.5186 21.3173 18.2901 21.7742 17.8331C22.2312 17.3762 22.4596 16.8269 22.4596 16.1852C22.4596 15.5436 22.2312 14.9942 21.7742 14.5373C21.3173 14.0804 20.768 13.8519 20.1263 13.8519C19.4846 13.8519 18.9353 14.0804 18.4784 14.5373C18.0214 14.9942 17.793 15.5436 17.793 16.1852C17.793 16.8269 18.0214 17.3762 18.4784 17.8331C18.9353 18.2901 19.4846 18.5186 20.1263 18.5186Z",
    fill: "#7F599D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.3e7e263e3de62a97fc8ab07778debab5.svg";
export { ForwardRef as ReactComponent };